var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-right"},[_c('b-badge',{attrs:{"variant":"light"}},[_vm._v(" "+_vm._s(_vm.minuteur)+" "),_c('b-icon',{attrs:{"icon":"arrow-clockwise","animation":"spin"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }